import { QueryObserverResult, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useRESTFetcher } from '../../../../api/useRESTFetcher';
import { API_URL } from '../../../../config/endpoints';
import { OnlineSchedulerDigitalForm } from '../types/onlineSchedulerDigitalForm.api.types';

interface QueryProps {
  uuid?: string;
}

export const useOnlineSchedulerDigitalForm = (
  op: { opcode: string },
  props: QueryProps,
  configProps?: UseQueryOptions<OnlineSchedulerDigitalForm | null>
): QueryObserverResult<OnlineSchedulerDigitalForm | null> => {
  const { koiFetch } = useRESTFetcher();
  const getQuery = async ({ uuid }: QueryProps) => {
    if (!uuid) return null;
    return koiFetch(`${API_URL}/forms/osDigitalForm?uuid=${uuid}`, { method: 'GET' });
  };

  return useQuery<OnlineSchedulerDigitalForm | null>({
    queryKey: ['forms/osDigitalForm', props],
    queryFn: () => getQuery(props),
    enabled: props.uuid != null,
    staleTime: Infinity,
    retryDelay: 2000,
    ...configProps,
    throwOnError: () => {
      console.error(`OPCODE: ${op.opcode}`);
      return true;
    },
  });
};
